<div class="home-new-page">

    <!-- Section 1: Hero -->
    <section class="hero-section">
        <div class="hero-overlay"></div>

        <div class="container-fluid position-relative hero-content-wrapper">
            <div class="hero-text-col">

                <h1 class="hero-headline">
                    <span [ngClass]="getHeadlineClass(1)">{{ 'home_new.hero_headline_1' | translate }}</span><br>
                    <span [ngClass]="getHeadlineClass(2)">{{ 'home_new.hero_headline_2' | translate }}</span><br>
                    <span class="text-black">{{ 'home_new.hero_headline_and' | translate }}</span><span [ngClass]="getHeadlineClass(3)">{{ 'home_new.hero_headline_3' | translate }}</span><br>
                    <span [ngClass]="getHeadlineClass(4)">{{ 'home_new.hero_headline_4' | translate }}</span>
                </h1>

                <p class="hero-subtitle">
                    {{ 'home_new.hero_subtitle' | translate }}
                </p>

                <div class="d-flex flex-column flex-sm-row gap-3 mb-4 hero-cta-wrapper">
                    <button
                        class="btn btn-outline-primary-green btn-lg fw-bold"
                        (click)="navigate('seller')">
                        {{ 'home_new.hero_cta' | translate }}
                    </button>
                </div>

                <div class="d-flex align-items-center gap-4 hero-badges">

                    <div class="d-flex align-items-center gap-2">
                        <div class="badge-icon-circle">
                            <i class="fa fa-shield-alt"></i>
                        </div>

                        <div>
                            <div class="fw-bold small">
                                {{ 'home_new.badge_trusted' | translate }}
                            </div>

                            <div class="text-muted small">
                                {{ 'home_new.badge_marketplace' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                        <div class="badge-icon-circle">
                            <i class="fa fa-chart-line"></i>
                        </div>

                        <div>
                            <div class="fw-bold small">
                                {{ 'home_new.badge_empowering' | translate }}
                            </div>

                            <div class="text-muted small">
                                {{ 'home_new.badge_agribusiness' | translate }}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </section>


    <!-- Section 2: Who We Serve & Tools For Farmers -->
    <div class="home-section home-section-border">

        <div class="text-center mb-5">

            <h2 class="section-title">
                {{ 'home_new.who_we_serve_title' | translate }}
            </h2>

            <p class="section-subtitle">
                {{ 'home_new.who_we_serve_subtitle' | translate }}
            </p>

        </div>

        <div class="row g-4">

            <div
                class="col-md-4"
                *ngFor="let prop of valueProps">

                <div class="card value-prop-card h-100">

                    <div class="card-icon-header">

                        <div class="card-icon me-3">
                            <i
                                class="fa"
                                [ngClass]="prop.icon">
                            </i>
                        </div>

                        <h3 class="card-title fw-bold mb-0">
                            {{ prop.title | translate }}
                        </h3>

                    </div>

                    <p class="card-text text-muted mb-4">
                        {{ prop.desc | translate }}
                    </p>

                    <a
                        *ngIf="prop.userType; else routerLinkBtn"
                        (click)="navigate(prop.userType)"
                        class="btn btn-primary-green mt-auto align-self-start"
                        style="cursor: pointer;">

                        {{ prop.linkLabel | translate }}

                        <i class="fa fa-arrow-right ms-1"></i>

                    </a>

                    <ng-template #routerLinkBtn>

                        <a
                            [routerLink]="prop.link"
                            class="btn btn-primary-green mt-auto align-self-start">

                            {{ prop.linkLabel | translate }}

                            <i class="fa fa-arrow-right ms-1"></i>

                        </a>

                    </ng-template>

                </div>

            </div>

        </div>

    </div>


    <!-- Section 3: Trending Orders -->
    <div class="home-section home-section-border">

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-end mb-5 gap-3">

            <div>

                <h2 class="section-title mb-2">
                    {{ 'home_new.trending_title' | translate }}
                </h2>

                <p class="section-subtitle mb-0">
                    {{ 'home_new.trending_subtitle' | translate }}
                </p>

            </div>

            <a
                routerLink="/marketplace"
                class="btn btn-outline-primary-green fw-bold">

                {{ 'home_new.view_more_products' | translate }}

            </a>

        </div>


        <div
            class="row g-3"
            *ngIf="!trendingLoading && trendingOffers.length > 0">

            <div
                class="col-6 col-md-4 col-lg-2"
                *ngFor="let offer of trendingOffers">

                <a
[routerLink]="[
                        '/products',
                        offer.product.slug || offer.product.name,
                        offer.id
                    ]"
                    class="category-tile">

                    <img
                        [src]="getTrendingImageSrc(offer)"
                        [alt]="getTrendingProductName(offer)"
                        class="category-tile-image">

                    <div class="category-tile-overlay"></div>

                    <div class="category-tile-label">

                        <h3 class="category-tile-name">
                            {{ getTrendingProductName(offer) }}
                        </h3>

                        <span class="category-tile-price">
                            {{ getTrendingPrice(offer) | number }}
                            {{ offer.currency | uppercase }}
                        </span>

                    </div>

                </a>

            </div>

        </div>


        <div
            class="row g-3"
            *ngIf="trendingLoading">

            <div
                class="col-6 col-md-4 col-lg-2"
                *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">

                <div class="category-tile category-tile-skeleton"></div>

            </div>

        </div>

    </div>


    <!-- Section 4: Built for the Entire Value Chain -->
    <div class="home-section home-section-border">

        <div class="row align-items-center g-5">

            <div class="col-lg-6">

                <img
                    src="assets/images/landing/procurement.png"
                    alt="Institutional procurement"
                    class="value-chain-img">

            </div>

            <div class="col-lg-6">

                <h2 class="section-title mb-3">
                    {{ 'home_new.value_chain_title' | translate }}
                </h2>

                <p class="section-subtitle mb-5">
                    {{ 'home_new.value_chain_subtitle' | translate }}
                </p>

                <div class="d-flex flex-column gap-4">

                    <div
                        class="d-flex gap-3"
                        *ngFor="let segment of segments">

                        <div class="segment-icon-circle flex-shrink-0">

                            <i
                                class="fa"
                                [ngClass]="segment.icon">
                            </i>

                        </div>

                        <div>

                            <h3 class="fw-bold mb-2">
                                {{ segment.title | translate }}
                            </h3>

                            <p class="text-muted mb-0">
                                {{ segment.desc | translate }}
                            </p>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>


    <!-- Section 5: Stats / Impact -->
    <section
        class="stats-band"
        #statsBand>

        <div class="container">

            <div class="row">

                <div
                    class="col-6 col-md-3 stats-col"
                    *ngFor="let stat of stats">

                    <div class="stats-item">

                        <div class="stats-value">
                            {{ stat.displayValue | translate }}
                        </div>

                        <div class="stats-label">
                            {{ stat.label | translate }}
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </section>


    <!-- Section 6: Streamlined B2B Procurement -->
    <div class="home-section home-section-border">

        <div class="text-center mb-5">

            <h2 class="section-title">
                {{ 'home_new.b2b_title' | translate }}
            </h2>

            <p class="section-subtitle">
                {{ 'home_new.b2b_subtitle' | translate }}
            </p>

        </div>

        <div class="row g-4 process-steps">

            <div
                class="col-md-3"
                *ngFor="let process of processes">

                <div class="process-step text-center">

                    <div class="process-circle">
                        {{ process.step }}
                    </div>

                    <h3 class="fw-bold mt-4 mb-2">
                        {{ process.title | translate }}
                    </h3>

                    <p class="text-muted small">
                        {{ process.desc | translate }}
                    </p>

                </div>

            </div>

        </div>

    </div>


    <!-- Section 7: Popular Blogs -->
    <div class="home-section home-section-border">

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-end mb-5 gap-3">

            <div>

                <h2 class="section-title mb-2">
                    {{ 'home_new.popular_blogs_title' | translate }}
                </h2>

                <p class="section-subtitle mb-0">
                    {{ 'home_new.popular_blogs_subtitle' | translate }}
                </p>

            </div>

        </div>


        <div
            class="row g-4"
            *ngIf="!blogLoading && blogPosts.length > 0">

            <div class="col-lg-6">

                <a
                    [routerLink]="[
                        '/blog',
                        blogPosts[0].slug,
                        blogPosts[0].id
                    ]"
                    class="blog-featured-link">

                    <div class="blog-featured-img-wrapper">

                        <img
                            [src]="getBlogImageSrc(blogPosts[0].imagePath)"
                            [alt]="blogPosts[0].title">

                    </div>

                    <div class="mt-4">

                        <h3 class="blog-featured-title blog-title-hover">
                            {{ blogPosts[0].title }}
                        </h3>

                        <p class="blog-featured-excerpt text-muted mb-3">
                            {{ getBlogExcerpt(blogPosts[0].body) }}
                        </p>

                        <span class="badge rounded-pill bg-primary-subtle text-primary fw-semibold px-3 py-2">
                            {{ 'home_new.read_more' | translate }}
                        </span>

                    </div>

                </a>

            </div>


            <div class="col-lg-6 d-flex flex-column gap-4">

                <a
                    [routerLink]="[
                        '/blog',
                        post.slug,
                        post.id
                    ]"
                    class="blog-side-link"
                    *ngFor="let post of blogPosts.slice(1, 4)">

                    <div class="blog-side-img-wrapper">

                        <img
                            [src]="getBlogImageSrc(post.imagePath)"
                            [alt]="post.title">

                    </div>

                    <div class="flex-grow-1">

                        <h3 class="blog-side-title blog-title-hover">
                            {{ post.title }}
                        </h3>

                        <p class="text-muted small mb-2">
                            {{ getBlogExcerpt(post.body) }}
                        </p>

                        <span class="badge rounded-pill bg-primary-subtle text-primary fw-semibold px-3 py-1">
                            {{ 'home_new.read_more' | translate }}
                        </span>

                    </div>

                </a>


                <div class="mt-4 text-end">

                    <a
                        routerLink="/blog"
                        class="btn btn-outline-primary-green fw-bold">

                        {{ 'home_new.view_more_articles' | translate }}

                        <i class="fa fa-arrow-right ms-1"></i>

                    </a>

                </div>

            </div>

        </div>


        <div
            class="row g-4"
            *ngIf="blogLoading">

            <div class="col-lg-6">

                <div class="blog-featured-img-wrapper bg-light"></div>

                <div class="mt-4">

                    <div class="placeholder-glow">
                        <span class="placeholder col-8"></span>
                    </div>

                    <div class="placeholder-glow mt-2">
                        <span class="placeholder col-12"></span>
                    </div>

                </div>

            </div>


            <div class="col-lg-6 d-flex flex-column gap-4">

                <div
                    class="d-flex gap-3"
                    *ngFor="let i of [1,2,3]">

                    <div class="blog-side-img-wrapper bg-light flex-shrink-0"></div>

                    <div class="flex-grow-1">

                        <div class="placeholder-glow">
                            <span class="placeholder col-8"></span>
                        </div>

                        <div class="placeholder-glow mt-2">
                            <span class="placeholder col-12"></span>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>


    <!-- Section 8: Our Partners and Clients -->
    <div class="home-section-green-bg">

        <div class="home-section">

            <div class="text-center mb-5">

                <span class="section-label">
                    {{ 'home_new.trusted_by' | translate }}
                </span>

                <h2 class="section-title mt-2">
                    {{ 'home_new.partners_title' | translate }}
                </h2>

            </div>


            <div
                class="d-flex flex-wrap align-items-center gap-3 partner-grid"
                *ngIf="!partnersLoading">

                <div
                    class="partner-logo-card"
                    *ngFor="let partner of partners">

                    <img
                        [src]="getPartnerLogoSrc(partner.image_path)"
                        [alt]="partner.name">

                </div>

            </div>


            <div
                class="d-flex flex-wrap align-items-center gap-3 partner-grid"
                *ngIf="partnersLoading">

                <div
                    class="partner-logo-card"
                    *ngFor="let i of [1,2,3,4,5,6,7]">

                    <div
                        class="placeholder-glow"
                        style="width: 80px; height: 40px;">

                        <span
                            class="placeholder col-12"
                            style="height: 100%;">
                        </span>

                    </div>

                </div>

            </div>

        </div>

    </div>


    <!-- Section 9: Testimonials -->
    <div class="home-section">

        <div class="text-center mb-4">

            <span class="section-label">
                {{ 'home_new.testimonial_label' | translate }}
            </span>

            <h2 class="section-title mt-2">
                {{ 'home_new.testimonial_title' | translate }}
            </h2>

        </div>


        <div
            class="row g-4 pt-4 testimonial-row"
            *ngIf="!testimonialsLoading && testimonials.length > 0">

            <div
                class="col-sm-6 col-lg-3"
                *ngFor="let t of testimonials">

                <div class="testimonial-card text-center">

                    <div class="testimonial-avatar">

                        <img
                            [src]="getTestimonialPhotoSrc(t.photo)"
                            [alt]="t.author">

                    </div>

                    <h3 class="testimonial-author">
                        {{ t.author }}
                    </h3>

                    <p class="text-muted small mb-3">
                        {{ t.role }}
                    </p>

                    <p class="testimonial-quote">
                        "{{ t.comment }}"
                    </p>

                    <div class="testimonial-stars">

                        <i
                            class="fa fa-star"
                            *ngFor="let s of stars">
                        </i>

                    </div>

                </div>

            </div>

        </div>


        <div
            class="row g-4 pt-4 testimonial-row"
            *ngIf="testimonialsLoading">

            <div
                class="col-sm-6 col-lg-3"
                *ngFor="let i of [1,2,3,4]">

                <div class="testimonial-card text-center">

                    <div class="testimonial-avatar bg-light"></div>

                    <div class="placeholder-glow mt-4">
                        <span class="placeholder col-6"></span>
                    </div>

                    <div class="placeholder-glow mt-2">
                        <span class="placeholder col-8"></span>
                    </div>

                    <div class="placeholder-glow mt-2">
                        <span class="placeholder col-12"></span>
                    </div>

                </div>

            </div>

        </div>

    </div>


    <!-- Reuse existing components -->
    <app-download-app></app-download-app>
    <app-services></app-services>

</div>